import { FACTION_LIST } from "@personnel/setting";
import type { FactionId } from "@personnel/setting";

interface FactionPickerProps {
  selected: FactionId | null;
  onChange: (faction: FactionId | null) => void;
}

export function FactionPicker({ selected, onChange }: FactionPickerProps) {
  return (
    <ul className="grid grid-cols-2 gap-2 sm:grid-cols-5">
      {FACTION_LIST.map((faction) => {
        const isSelected = selected === faction.id;
        return (
          <li key={faction.id}>
            <button
              type="button"
              // Clicking the selected faction clears it, since faction is optional.
              onClick={() => onChange(isSelected ? null : faction.id)}
              aria-pressed={isSelected}
              title={faction.name}
              className={`flex w-full flex-col items-center gap-2 rounded-lg border p-3 transition-colors ${
                isSelected
                  ? "border-leviathan-600 bg-leviathan-600/10"
                  : "border-void-800 hover:border-leviathan-600/60"
              }`}
            >
              <img
                src={faction.flag}
                alt=""
                width={64}
                height={64}
                loading="lazy"
                className={`size-12 rounded shadow-sm transition-opacity ${
                  isSelected ? "opacity-100" : "opacity-70"
                }`}
              />
              <span className="text-center text-[11px] leading-tight text-void-400">
                {faction.name}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
